





























import { announcementController } from '@/api/Agency/agency.api'
import { Announcement } from '@/api/Agency/agency.interface'
import Vue, { PropType } from 'vue'
export default Vue.extend({
  props: {
    messages: {
      type: Array as PropType<Announcement[]>,
      default: (): Announcement[] => [],
    },
  },
  data() {
    return {
      items: this.messages as Announcement[],
    }
  },
  computed: {
    currentItem(): Announcement {
      return this.items[0] || {}
    },
  },
  watch: {
    messages(messages: Announcement[]) {
      this.items = messages
    },
  },

  mounted() {
    if (this.$p.isAdmin) {
      const today = new Date().toISOString().substring(0, 10)
      announcementController
        .getter({
          is_active: true,
          start_date__lte: today,
          end_date__gte: today,
        })
        .then(({ data }) => {
          this.items = data.results
        })
    }
  },
})
